(() => {
  const shuffledContainers = new WeakMap();

  const getProductItems = (container) =>
    [...container.children].filter((item) => {
      if (!(item instanceof HTMLElement)) return false;
      return item.matches('.product-grid__item, .resource-list__item') && item.querySelector('product-card, product-card-link');
    });

  const seededValue = (value, seed) => {
    let hash = seed || 2166136261;
    for (let index = 0; index < value.length; index += 1) {
      hash ^= value.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
  };

  const shuffleItems = (items, seed) =>
    items
      .map((item, index) => {
        const productId = item.dataset.productId || item.querySelector('[data-product-id]')?.dataset.productId || String(index);
        return { item, order: seededValue(`${productId}:${index}`, seed) };
      })
      .sort((a, b) => a.order - b.order)
      .map(({ item }) => item);

  const randomizeContainer = (container) => {
    if (!(container instanceof HTMLElement)) return;

    const items = getProductItems(container);
    if (items.length < 3) return;

    const signature = items
      .map((item) => item.dataset.productId || item.querySelector('[data-product-id]')?.dataset.productId || item.id)
      .join('|');

    if (shuffledContainers.get(container) === signature) return;
    shuffledContainers.set(container, signature);

    const seed = Date.now() + Math.floor(Math.random() * 100000);
    const fragment = document.createDocumentFragment();
    shuffleItems(items, seed).forEach((item) => fragment.appendChild(item));
    container.appendChild(fragment);
  };

  const randomizeProductLists = (root = document) => {
    root.querySelectorAll?.('.product-grid, .resource-list--grid').forEach(randomizeContainer);
  };

  const scheduleRandomize = (root) => {
    window.requestAnimationFrame(() => randomizeProductLists(root));
  };

  document.addEventListener('DOMContentLoaded', () => {
    randomizeProductLists();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        const target = mutation.target instanceof HTMLElement ? mutation.target : document;
        if (
          target.matches?.('.product-grid, .resource-list--grid, results-list') ||
          target.querySelector?.('.product-grid, .resource-list--grid')
        ) {
          scheduleRandomize(target);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
